import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductTradeInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);

    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    if (variantId) {
      this.#updateWithVariantData(variantId);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog, [id*="ProductInformation-"]');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event by updating the trade info / stock status.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const variantId = event.detail?.variantId || event.detail?.resource?.id;
    if (variantId) {
      this.#updateWithVariantData(variantId);
    }

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
          const newTradeInfo = html.querySelector('product-trade-info');
          if (newTradeInfo) {
            morph(this, newTradeInfo, { childrenOnly: true });
          }
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        if (variantId) {
          this.#updateWithVariantData(variantId);
        }
      })
      ?.catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-trade-info] Event promise rejected:', error);
      });
  };

  #updateWithVariantData(variantId) {
    const script = this.querySelector('script[data-trade-info-variants]');
    if (!script) return;

    try {
      const variantsData = JSON.parse(script.textContent);
      const data = variantsData[variantId];
      if (!data) return;

      const statusContainer = this.querySelector('.product-trade-info__status-container') || this;
      const allStatusEls = statusContainer.querySelectorAll('.product-trade-info__lead-time');

      if (data.status_text) {
        let activeEl = null;
        if (data.class_name) {
          const firstClass = data.class_name.split(' ')[0];
          activeEl = statusContainer.querySelector(`.product-trade-info__lead-time.${firstClass}`);
        }
        if (!activeEl) {
          activeEl = statusContainer.querySelector('.product-trade-info__lead-time');
        }

        allStatusEls.forEach((el) => {
          if (el !== activeEl) {
            el.classList.add('hide');
            el.style.display = 'none';
          }
        });

        if (activeEl) {
          if (data.class_name) {
            activeEl.className = `product-trade-info__lead-time ${data.class_name}`;
          }
          activeEl.classList.remove('hide');
          activeEl.style.display = 'flex';
          const textSpan = activeEl.querySelector('.product-trade-info__text');
          const dotEl = activeEl.querySelector('.product-trade-info__dot');

          if (textSpan) {
            if (data.is_html) {
              textSpan.innerHTML = data.status_text;
            } else {
              textSpan.textContent = data.status_text;
            }
          }
          if (dotEl) {
            dotEl.classList.toggle('dot_green', Boolean(data.in_stock));
          }
        }
      } else {
        allStatusEls.forEach((el) => {
          el.classList.add('hide');
          el.style.display = 'none';
        });
      }
    } catch (e) {
      console.warn('[product-trade-info] Failed to parse variants data:', e);
    }
  }
}

if (!customElements.get('product-trade-info')) {
  customElements.define('product-trade-info', ProductTradeInfo);
}
